import { createFileRoute, redirect } from "@tanstack/react-router"

import { validateAdLibrarySearch } from "~/components/AdLibrary/adFilters"

export const Route = createFileRoute("/ad-library")({
  validateSearch: validateAdLibrarySearch,
  beforeLoad: ({ location, search }) => {
    const legacyDetailPrefix = "/ad-library/"
    const legacyAdId = location.pathname.startsWith(legacyDetailPrefix)
      ? location.pathname.slice(legacyDetailPrefix.length)
      : undefined

    return redirect({
      to: "/admin/ad-library",
      search: { ...search, adId: legacyAdId || search.adId },
      replace: true,
      throw: true,
    })
  },
})
